import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import '../../src/App.css';
import '../css/Login.css';

import apiManager from '../api/apiManager';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Login - Construction and Engineering";  // Set the page title
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", "Login to your Construction and Engineering Saudi Arabia account.");
        }

        // Add the 'login-body' class to the body
        document.body.classList.add('login-body');

        // Cleanup: Remove the 'login-body' class when the component unmounts
        return () => {
            document.body.classList.remove('login-body');
        };
    }, []);


    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setLoading(true);

        try {
            const result = await apiManager.post('/auth/login', {
                email: email,
                password: password
            });

            localStorage.setItem('token', result.data.token);
            navigate('/dashboard');
        } catch (error) {
            // Clean up AdonisJS error format
            const cleaned = error.message?.includes(':')
                ? error.message.split(':').pop().trim()
                : error.message;

            setErrorMessage(cleaned || 'Login failed. Please try again.');
        }

        setLoading(false);
    };

    return (
        <>
            {loading && (
                <div className="loading-overlay">
                    <div className="progress-bar"></div>
                </div>
            )}

            <div className="login-container">
                <div className='top'>
                    <img src="/images/logo.png" alt="Logo" />
                    <h1>Log in to your account</h1>
                </div>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <div className="password-wrapper">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <span
                            className="toggle-password"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                    </div>
                    {errorMessage && <div className="error-message">{errorMessage}</div>}

                    <button type="submit">Sign in</button>
                </form>
                <a href="/forgot">Need help signing in?</a>
            </div>
        </>
    );
};

export default Login;
